export default __webpack_public_path__ + "static/media/ee.294c52fa.svg";